import { store } from "@store/store";
import { setToastData } from "@store/slices/globalState";
import {
  skipLottieAnimation,
  updateLottieAnimationKey,
  updateRedirectionDone
} from "@store/slices/lottieState";
import { updateLoader } from "@store/slices/config";
import { dashcamInstallationCheckout } from "../dashcamInstallationCheckout";
import { dashcamInstallationConfirmation } from "../dashcamInstallationConfirmation";
import Cookies from "js-cookie";
import Router from "next/router";

export const checkoutAndRedirectToPayment = async (data: any) => {
  const skipPayment =
    String(Router.query.collectPayment).toLowerCase() === "false";

  try {
    if (skipPayment) {
      store?.dispatch(updateLoader(true));

      const response = await dashcamInstallationConfirmation(data);
      const { callback_url, success } = response || {};

      if (success && callback_url && typeof window !== "undefined") {
        window.location.href = callback_url;
      } else {
        store?.dispatch(updateLoader(false));
        store?.dispatch(
          setToastData({
            toastMessage: response?.message || "Unable to confirm installation",
            toastMessageType: "error"
          })
        );
      }
      return;
    }

    store?.dispatch(
      updateLottieAnimationKey({
        showLottie: true,
        lottieAnimationKey: "LOADER_ANIMATION",
        customAnimationText: "Redirecting to payment gateway...",
        nextNodeSuccess: false
      })
    );

    const response = await dashcamInstallationCheckout(data);

    const { redirection_url, success } = response || {};
    if (success && redirection_url && typeof window !== "undefined") {
      if (Cookies.get("webview")) {
        setTimeout(() => {
          store?.dispatch(updateRedirectionDone({ redirectionDone: true }));
          store?.dispatch(skipLottieAnimation({ showLottie: false }));
        }, 200);
      }

      window.location.href = redirection_url;
    } else {
      store?.dispatch(
        setToastData({
          toastMessage: response?.message || "Unable to redirect to payment gateway",
          toastMessageType: "error"
        })
      );
      store?.dispatch(skipLottieAnimation({ showLottie: false }));
    }
  } catch (error: any) {
    console.error("checkoutAndRedirectToPayment Error:", error);
    store?.dispatch(
      setToastData({
        toastMessage: "Something went wrong",
        toastMessageType: "error"
      })
    );
    store?.dispatch(updateLoader(false));
    store?.dispatch(skipLottieAnimation({ showLottie: false }));
  }
};
